import {
  ADD_BOX,
  ADD_NAV_ITEM,
  DELETE_BOX,
  DELETE_SORTABLE_CONTAINER,
  DELETE_NAV_ITEM,
  SELECT_BOX,
  DELETE_CONTAINED_VIEW,
  SELECT_CONTAINED_VIEW,
  SELECT_NAV_ITEM,
  IMPORT_STATE,
  PASTE_BOX,
  INDEX_SELECT,
  DUPLICATE_NAV_ITEM,
  DUPLICATE_NAV_ITEM_BY_PAYLOAD,
  SELECT_BOX_ALL,
  SELECT_BOX_TOGGLE,
} from "../common/actions";
import { ID_PREFIX_BOX } from "../common/constants";
import { isBox, isSortableBox, isContainedView, isPage } from "../common/utils";

export default function (state = -1, action = {}) {
  switch (action.type) {
    case ADD_BOX:
      return -1;
    case ADD_NAV_ITEM:
      return -1;
    case DELETE_BOX:
      return -1;
    case DELETE_SORTABLE_CONTAINER:
      return -1;
    case DELETE_NAV_ITEM:
      return -1;
    case DELETE_CONTAINED_VIEW:
      return -1;
    case SELECT_BOX:
      return -1;
    case SELECT_BOX_ALL:
      return action.payload.id;
    case SELECT_BOX_TOGGLE: {
      const toggled = action.payload.id;
      let current = Array.isArray(state) ? [...state] : [];
      // Seed from the single selection so a modifier-click adds instead of replacing.
      const single = action.payload.current;
      if (current.length === 0 && single !== undefined && single !== -1 && isBox(single)) {
        current = [single];
      }
      if (current.includes(toggled)) {
        const next = current.filter((id) => id !== toggled);
        return next.length === 0 ? -1 : next;
      }
      return [...current, toggled];
    }
    case SELECT_CONTAINED_VIEW:
      return -1;
    case INDEX_SELECT:
      return -1;
    case SELECT_NAV_ITEM:
      return -1;
    case IMPORT_STATE:
      return -1;
    case PASTE_BOX:
      return -1;
    case DUPLICATE_NAV_ITEM:
      return -1;
    case DUPLICATE_NAV_ITEM_BY_PAYLOAD:
      return -1;
    default:
      return state;
  }
}
